import { makeStyles } from '@mui/styles';
// import { Theme } from '@mui/material';

const profileStyle = makeStyles(() => ({
    mainContainer: {},
}));

export default profileStyle;
